// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    // FacebookMessengerIcon,
    // FacebookMessengerShareButton,
    FacebookShareButton,
    HatenaIcon,
    HatenaShareButton,
    InstapaperIcon,
    InstapaperShareButton,
    LineIcon,
    LineShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    LivejournalIcon,
    LivejournalShareButton,
    MailruIcon,
    MailruShareButton,
    OKIcon,
    OKShareButton,
    // PinterestIcon,
    // PinterestShareButton,
    PocketIcon,
    PocketShareButton,
    RedditIcon,
    RedditShareButton,
    TelegramIcon,
    TelegramShareButton,
    TumblrIcon,
    TumblrShareButton,
    TwitterIcon,
    TwitterShareButton,
    VKIcon,
    VKShareButton,
    ViberIcon,
    ViberShareButton,
    WeiboIcon,
    WeiboShareButton,
    WhatsappIcon,
    WhatsappShareButton,
    WorkplaceIcon,
    WorkplaceShareButton,
} from 'react-share';

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// pages
import {
    EditBlockSite,
} from 'pages'

// serializers
import {
    CustomCSSProperties,
    MainStyleSerializer,
    PortfolioPageContentListSiteSerializer,
    Template818SiteSerializer,
} from 'serializers/site'

// services
import {
    getStylesNew,
} from 'services'

// props
type TemplateBlock818SiteProps = {
    blockId: string
    content: Template818SiteSerializer | undefined
    isEditHovered: boolean
    mainParentId?: number
    object: PortfolioPageContentListSiteSerializer
    parentArray?: number[]
    parentStyles?: any
    styles: MainStyleSerializer
    stylesEdit: MainStyleSerializer | undefined
}

// main
export const TemplateBlock818Site: React.FC<TemplateBlock818SiteProps> = React.memo(({
    blockId,
    content,
    isEditHovered,
    mainParentId,
    object,
    parentArray,
    parentStyles,
    styles,
    stylesEdit,
}) => {

    const dispatch = useDispatch()
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    const [stylesNew, setStylesNew] = useState<CustomCSSProperties | undefined>(applyStyles())

    useEffect(() => {
        setStylesNew(applyStyles())
    }, [
        object.id,
        reduxModalSite,
        styles,
        stylesEdit,
    ])


    function applyStyles() {
        try {
            return getStylesNew(reduxModalSite, styles, stylesEdit)
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock818Site',
                'applyStyles',
            ))
        }
    }

    const iconProps = {
        round: stylesNew?.isRound === 'false' ? false : true,
        size: stylesNew?.iconSize || 32,
    }

    const url = content?.text4 || window.location.href

    const buttonDict: any = {
        'email': (
            <EmailShareButton
                body={content?.text3}
                subject={content?.text2}
                url={url}
            >
                <EmailIcon {...iconProps} />
            </EmailShareButton>
        ),
        'facebook': (
            <FacebookShareButton
                // title={content?.text3}
                url={url}
            >
                <FacebookIcon {...iconProps} />
            </FacebookShareButton>
        ),
        // 'facebookmessenger': (
        //     <FacebookMessengerShareButton
        //     title={content?.text3}
        //     url={url}
        // >
        //         <FacebookMessengerIcon {...iconProps} />
        //     </FacebookMessengerShareButton>
        // ),
        'hatena': (
            <HatenaShareButton
                title={content?.text3}
                url={url}
            >
                <HatenaIcon {...iconProps} />
            </HatenaShareButton>
        ),
        'instapaper': (
            <InstapaperShareButton
                title={content?.text3}
                url={url}
            >
                <InstapaperIcon {...iconProps} />
            </InstapaperShareButton>
        ),
        'line': (
            <LineShareButton
                title={content?.text3}
                url={url}
            >
                <LineIcon {...iconProps} />
            </LineShareButton>
        ),
        'linkedin': (
            <LinkedinShareButton
                summary={content?.text3}
                url={url}
            >
                <LinkedinIcon {...iconProps} />
            </LinkedinShareButton>
        ),
        'livejournal': (
            <LivejournalShareButton
                title={content?.text3}
                url={url}
            >
                <LivejournalIcon {...iconProps} />
            </LivejournalShareButton>
        ),
        'mailru': (
            <MailruShareButton
                title={content?.text3}
                url={url}
            >
                <MailruIcon {...iconProps} />
            </MailruShareButton>
        ),
        'ok': (
            <OKShareButton
                title={content?.text3}
                url={url}
            >
                <OKIcon {...iconProps} />
            </OKShareButton>
        ),
        // 'pinterest': (
        //     <PinterestShareButton
        // title={content?.text3}
        // url={url}
        // >
        //         <PinterestIcon {...iconProps} />
        //     </PinterestShareButton>
        // ),
        'pocket': (
            <PocketShareButton
                title={content?.text3}
                url={url}
            >
                <PocketIcon {...iconProps} />
            </PocketShareButton>
        ),
        'reddit': (
            <RedditShareButton
                title={content?.text3}
                url={url}
            >
                <RedditIcon {...iconProps} />
            </RedditShareButton>
        ),
        'telegram': (
            <TelegramShareButton
                title={content?.text3}
                url={url}
            >
                <TelegramIcon {...iconProps} />
            </TelegramShareButton>
        ),
        'tumblr': (
            <TumblrShareButton
                title={content?.text3}
                url={url}
            >
                <TumblrIcon {...iconProps} />
            </TumblrShareButton>
        ),
        'twitter': (
            <TwitterShareButton
                title={content?.text3}
                url={url}
            >
                <TwitterIcon {...iconProps} />
            </TwitterShareButton>
        ),
        'vk': (
            <VKShareButton
                title={content?.text3}
                url={url}
            >
                <VKIcon {...iconProps} />
            </VKShareButton>
        ),
        'viber': (
            <ViberShareButton
                title={content?.text3}
                url={url}
            >
                <ViberIcon {...iconProps} />
            </ViberShareButton>
        ),
        'weibo': (
            <WeiboShareButton
                title={content?.text3}
                url={url}
            >
                <WeiboIcon {...iconProps} />
            </WeiboShareButton>
        ),
        'whatsapp': (
            <WhatsappShareButton
                title={content?.text3}
                url={url}
            >
                <WhatsappIcon {...iconProps} />
            </WhatsappShareButton>
        ),
        'workplace': (
            <WorkplaceShareButton
                title={content?.text3}
                url={url}
            >
                <WorkplaceIcon {...iconProps} />
            </WorkplaceShareButton>
        ),
    }

    const socialString = content?.text

    return (
        <div
            id={blockId}
            className={`template-block-818${isEditHovered ? ' is-edit-hovered' : ''} ${deviceType}`}
            style={{
                justifyContent: stylesNew?.justifyContent || 'flex-start',
            }}
        >
            {socialString?.split(',').map((social) => (
                <div
                    key={social}
                    className={`t-818-button ${deviceType}`}
                    style={{
                        padding: stylesNew?.padding || 0,
                    }}
                >
                    {buttonDict[social]}
                </div>
            ))}
            <NativeShareButton
                deviceType={deviceType}
                stylesNew={stylesNew}
                text={content?.text3}
                url={url}
            />
            <EditBlockSite
                mainParentId={mainParentId || object.id!}
                object={object}
                parentArray={parentArray}
                parentStyles={parentStyles}
            />
        </div>
    )
})

type NativeShareButtonProps = {
    url: string
    title?: string
    text?: string
    stylesNew?: CustomCSSProperties
    deviceType?: string
}

const NativeShareButton: React.FC<NativeShareButtonProps> = React.memo(({
    deviceType,
    stylesNew,
    text,
    title,
    url,
}) => {

    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    // title: '',
                    text: text,
                    // text: text + '\n\n' + url,
                    url: url,
                })
                if (process.env.NODE_ENV === 'development') console.log('Content shared successfully!')
            } catch (error) {
                if (process.env.NODE_ENV === 'development') console.error('Error while sharing:', error)
            }
        } else {
            if (process.env.NODE_ENV === 'development') console.warn("Native sharing is not supported in this browser.")
            alert("Native sharing is not supported on this browser.")
        }
    }

    return (
        <div
            className={`t-818-button ${deviceType}`}
            style={{
                padding: stylesNew?.padding || 0,
            }}
        >
            <button
                onClick={handleShare}
                style={{
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: 'black',
                    cursor: 'pointer',
                    display: 'flex',
                    font: 'inherit',
                    height: '32px',
                    justifyContent: 'center',
                    padding: '0px',
                    width: '32px',
                }}
            >
                <i
                    className='main-icon mo-new-icon-share-solid'
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '25px',
                        justifyContent: 'center',
                    }}
                />
            </button>
        </div>
    )
})
